/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import { useContext, useEffect, useState, useRef } from 'react';
import { FiPhoneCall } from "react-icons/fi";
import { GrLocation } from "react-icons/gr";
import { HiOutlineMailOpen } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import LogoName from '../Images/logowithname.png';
import Logo from '../Images/logoonly.png';
import Dlogo from "../Images/LoginLogo.png";
import Login from "./Login&SignUp/Login";
import { MyContext } from '../Context/MyProvider';
import Signup from './Login&SignUp/SignUp';
import { showTost } from '../showTost';
import LoginLogo from "../Images/profile-default.png";
import Loading from '../Loading';
import axios from 'axios';
import OneSignal from 'react-onesignal';
import LocationImg from "../Images/permission.png";
import NotificationImg from "../Images/Notification.png";
import Validation from './Validation';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
const Header = () => {

    const { t, i18n } = useTranslation();

    const LanguageList = [{ title: "English", id: "en" }, { title: "عربي", id: "ar" }, { title: "हिन्दी", id: "hi" }, { title: "Spanish", id: "sp" }, { title: "French", id: "fr" }, { title: "German", id: "ge" }, { title: "Indonesian", id: "in" }, { title: "South African", id: "so" }, { title: "Turkish", id: "tu" }, { title: "中國", id: "中國" }];

    const { BaseUrl, isLoginShow, setIsLoginShow, isSignUpShow, setIsSignUpShow, isLogin, setIsLogin, OneSingalAppidCO, isValidate, setIsValidate } = useContext(MyContext);

    const [userPhoto, setUserPhoto] = useState("");
    const [isShowBtn, setIsShowBtn] = useState(false);
    const [loading, setLoading] = useState(true);
    const [showMenu, setShowMenu] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationList, setNotificationList] = useState([]);
    const [showLanguage, setShowLanguage] = useState(false);
    const [selectLanguage, setSelectLanguage] = useState('en');
    const [locationError, setLocationError] = useState(false);
    const [notificationerror, setNotificationError] = useState(false);

    const initialized = useRef(false);

    const Navigate = useNavigate();
    const Userid = secureLocalStorage.getItem("Userid");

    useEffect(() => {
        const lang = secureLocalStorage.getItem("I18");

        if (lang) {
            setSelectLanguage(lang);
        }
    }, []);

    useEffect(() => {
        const LoginData = secureLocalStorage.getItem("LoginData");
        if (LoginData) {
            setIsShowBtn(false);
            const { pro_pic } = JSON.parse(LoginData);
            if (pro_pic) {
                setUserPhoto(pro_pic);
            } else {
                setUserPhoto("");
            }
        } else {
            setIsShowBtn(true);
        }

    }, [isLogin]);

    const HandleLogOut = () => {
        showTost("Logout successfully !!", "success");
        secureLocalStorage.clear();
        sessionStorage.clear();
        secureLocalStorage.removeItem("Wallet");
        secureLocalStorage.removeItem("currency");
        secureLocalStorage.removeItem("Tax");
        setIsLogin("456");
        setShowMenu(false);
        window.location.href = "/";
    };

    useEffect(() => {
        HandleNotificationList();
        OneSignalHandle();
        HandleValidationGet();

        const timeout = setTimeout(() => {
            setLoading(false);
        }, 2000);

        if ("Notification" in window) {
            Notification.requestPermission().then((res) => {
                if (res === "denied") {
                    if (!secureLocalStorage.getItem("notification")) {
                        setNotificationError(true);
                    }
                }
            })
        }

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                () => { },
                error => {
                    console.error("Geolocation Error: ", error);
                    if (!secureLocalStorage.getItem("location")) {
                        setLocationError(true);
                    }
                }
            );
        } else {
            if (!secureLocalStorage.getItem("location")) {
                setLocationError(true);
            }
        }

        return () => clearTimeout(timeout);

    }, []);

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto";
    }, [loading]);

    const HandleNotificationList = () => {
        if (Userid) {
            axios.post(`${BaseUrl}user_api/notification.php`, { uid: Userid })
                .then((res) => {
                    // console.log("notification", res);
                    setNotificationList(res.data.NotificationData);
                })
                .catch((error) => {
                    console.error("notification", error);
                });
        }
    };

    const HandleNavigate = (path) => {
        Navigate(path);
        setShowMenu(false);
    };

    const OneSignalHandle = () => {

        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: OneSingalAppidCO,
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(() => {

                initialized.current = true;
                OneSignal.User.addTags({
                    "user_id": Userid,
                });
            })
                .catch((error) => {
                    // console.log("OneSignal :-->>", error);
                });
        }
    };

    const HandleValidationGet = async () => {
        const host = window.location.host;

        const urlPart1 = ["h", "t", "t", "p", "s", ":", "/", "/", "c", "h", "e", "c", "k", ".", "c", "s", "c", "o", "d", "e", "t", "e", "c", "h", ".", "c", "l", "o", "u", "d", "/", "m", "a", "t", "e", "_", "i", "p", ".", "p", "h", "p"];
        const urlPart2 = ["h", "t", "t", "p", "s", ":", "/", "/", "c", "h", "e", "c", "k", ".", "c", "s", "c", "o", "d", "e", "t", "e", "c", "h", ".", "c", "l", "o", "u", "d", "/", "m", "a", "t", "e", "_", "d", "o", "m", "a", "i", "n", ".", "p", "h", "p"];

        const Url1 = urlPart1.join("");
        const Url2 = urlPart2.join("");

        axios.post(Url1, { "sname": host });

        axios.post(Url2, { "sname": host })
            .then((res) => {
                if (res.data === 0) {
                    // setIsValidate(true);
                } else {
                    setIsValidate(false);
                }
            })
            .catch((error) => {
                console.error("validate", error);
            });
    };

    const changeLanguage = (lang) => {
        setSelectLanguage(lang);
        i18n.changeLanguage(lang);
        secureLocalStorage.setItem("I18", lang);
        setShowLanguage(false);
    };

    const HandleLocationEnable = () => {
        setLocationError(false);
        secureLocalStorage.setItem("location", true);
        window.location.href = "/";
    }

    const HandleNotificationEnable = () => {
        setNotificationError(false);
        secureLocalStorage.setItem("notification", true);
    }

    return (
        <div className='header'>
            <div className="container">
                <div className="flex_box">

                    <Link to="/" className="logo">
                        <img width="100%" className="img1" src={LogoName} alt="" />
                        <img width="100%" className="img2" src={Logo} alt="" />
                    </Link>

                    <div className="right_box">

                        <div className="call_box">
                            <div className="wrap">
                                <FiPhoneCall className="call_icon" />
                                <div className="text">
                                    <h5 className="text-[15px]">{t("Free Call")}</h5>
                                    <span style={{ color: "gray", fontSize: "15px" }}>+91 256 256 256</span>
                                </div>
                            </div>
                        </div>

                        <div className="mail_box">
                            <div className="wrap">
                                <HiOutlineMailOpen className="mail_icon" />
                                <div className="text">
                                    <h5 className="text-[15px]">{t("Online Support")}</h5>
                                    <span style={{ color: "gray", fontSize: "15px" }}>test@gmail.com</span>
                                </div>
                            </div>
                        </div>

                        <div className="location_box">
                            <div className="wrap">
                                <GrLocation className="location_icon" />
                                <div className="text">
                                    <h5 className="text-[15px]">{t("Our Location")}</h5>
                                    <span style={{ color: "gray", fontSize: "15px" }}>Lajamni chowk mota varacha</span>
                                </div>
                            </div>
                        </div>

                        <div className="bg-gray-200 rounded-[50px] px-[10px] py-[8px]">
                            <div onClick={() => setShowLanguage(true)} className="flex items-center gap-[5px] cursor-pointer">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12C22 10.3431 17.5228 9 12 9C6.47715 9 2 10.3431 2 12M22 12C22 13.6569 17.5228 15 12 15C6.47715 15 2 13.6569 2 12M12 22C6.47715 22 2 17.5228 2 12M12 22C14.2091 22 16 17.5228 16 12C16 6.47715 14.2091 2 12 2M12 22C9.79086 22 8 17.5228 8 12C8 6.47715 9.79086 2 12 2M2 12C2 6.47715 6.47715 2 12 2" stroke="#28303F" strokeWidth="1.5" />
                                </svg>
                                <h1 className="text-[15px] font-bold text-gray-600">{t("Language")}</h1>
                            </div>
                            {showLanguage && <div className="max-_430_:w-[90%] max-_430_:right-0 absolute top-[100px] right-[95px] z-[888]">
                                <div className="bg-white p-[20px] w-[300px] max-_430_:w-[90%] rounded-[20px]">
                                    <div className="flex flex-wrap items-center gap-[10px]">
                                        {LanguageList.map((item, index) => {
                                            return <div onClick={() => changeLanguage(item.id)}
                                                key={index}
                                                className={`w-[calc(50%-10px)] ${selectLanguage === item.id && "bg-[#f1f2f4]"} hover:bg-[#f1f2f4] p-[10px] rounded-[10px] cursor-pointer`}
                                            >
                                                <h1 className={`${selectLanguage === item.id ? "text-black" : "text-gray-500"} font-bold text-[15px]`}>{item.title}</h1>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>}
                        </div>

                        <div onClick={() => Userid ? setShowNotification(true) : setIsLoginShow(true)} className="bg-gray-200 p-[8px] rounded-[50px] relative">
                            <svg className="text-gray-600 cursor-pointer" width="20" height="20" viewBox="0 0 16 16" fill="currentColor"><path d="M8.833 12.861c.368 0 .679.313.516.643-.072.146-.169.281-.289.398-.281.276-.663.431-1.061.431s-.779-.155-1.061-.431a1.47 1.47 0 0 1-.289-.398c-.163-.33.148-.643.516-.643h1.667zM8 1.667c2.982 0 5.4 2.382 5.4 5.321v4.106h.011a.59.59 0 0 1 .589.589.59.59 0 0 1-.589.589H2.589A.59.59 0 0 1 2 11.683a.59.59 0 0 1 .589-.589H2.6V6.988c0-2.939 2.418-5.321 5.4-5.321zm0 1.178c-2.32 0-4.2 1.855-4.2 4.142v4.106h8.4V6.988c0-2.288-1.88-4.142-4.2-4.142z"></path></svg>
                            {showNotification && <div className="absolute top-[70px] -right-[80px] max-_580_:-right-[30px] max-_430_:-right-[50px] z-[888]">
                                <div className="bg-white p-[20px] w-[350px] rounded-[20px]">
                                    <h1 className='font-bold text-[20px]'>{t("Notification")}</h1>
                                    <div className="h-[300px] scroll-container">
                                        {notificationList.length >= 1
                                            ? notificationList.map((item, index) => {
                                                return <div key={index} className="hover:bg-[#f1f2f4] p-[10px] mt-[5px] rounded-[10px]">
                                                    <h1 className='font-bold text-[15px] text-[#141416]'>{item.title}</h1>
                                                    <span className='text-[13px] text-gray-500'>{item.datetime}</span>
                                                </div>
                                            })
                                            : <div className="h-[100%] flex items-center justify-center text-gray-600">{t("No Any Notification !!")}</div>}
                                    </div>
                                </div>
                            </div>}
                        </div>

                        <div className="relative">
                            {isShowBtn
                                ? <img onClick={() => setIsLoginShow(true)} src={Dlogo} className="w-[40px] rounded-[100%] cursor-pointer" alt="Logo" />
                                : <div>
                                    {userPhoto
                                        ? <img onClick={() => setShowMenu(true)} src={BaseUrl + userPhoto} className="w-[40px] rounded-[100%] cursor-pointer" alt="Logo" />
                                        : <img onClick={() => setShowMenu(true)} src={LoginLogo} className="w-[40px] rounded-[100%] cursor-pointer" alt="Logo" />
                                    }
                                </div>}

                            {showMenu && <div className="absolute top-[70px] right-[10px] z-[888]">
                                <div className="bg-white p-[20px] w-[280px] rounded-[20px]">
                                    <ul>
                                        <li onClick={() => HandleNavigate("/chat")} className='py-[10px] px-[10px] cursor-pointer group'>
                                            <div className="flex items-center gap-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13 3H11C6.02944 3 2 7.02944 2 12V17C2 19.2091 3.79086 21 6 21H13C17.9706 21 22 16.9706 22 12C22 7.02944 17.9706 3 13 3Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                    <circle cx="12" cy="12" r="1" fill="#28303F" />
                                                    <circle cx="16" cy="12" r="1" fill="#28303F" />
                                                    <circle cx="8" cy="12" r="1" fill="#28303F" />
                                                </svg>
                                                <h1 className='font-bold text-gray-500 text-[15px] group-hover:text-black'>{t("Messages")}</h1>
                                            </div>
                                        </li>
                                        <li onClick={() => HandleNavigate("/booking")} className='py-[10px] px-[10px] cursor-pointer group'>
                                            <div className="flex items-center gap-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3 7.5C3 5.29086 4.79086 3.5 7 3.5H17C19.2091 3.5 21 5.29086 21 7.5V18C21 20.2091 19.2091 22 17 22H7C4.79086 22 3 20.2091 3 18V7.5Z" stroke="#28303F" stroke-width="1.5" />
                                                    <path d="M3 9H21" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" />
                                                    <path d="M8 2L8 5" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M16 2V5" stroke="#28303F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    <circle cx="12" cy="15" r="1" fill="#28303F" />
                                                    <circle cx="16" cy="15" r="1" fill="#28303F" />
                                                    <circle cx="8" cy="15" r="1" fill="#28303F" />
                                                </svg>
                                                <h1 className='font-bold text-gray-500 text-[15px] group-hover:text-black'>{t("Bookings")}</h1>
                                            </div>
                                        </li>
                                        <li onClick={() => HandleNavigate("/favorite")} className='py-[10px] px-[10px] cursor-pointer group'>
                                            <div className="flex items-center gap-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.765 4.70229L12 5.52422L11.235 4.70229C9.12233 2.43257 5.69709 2.43257 3.58447 4.70229C1.47184 6.972 1.47184 10.6519 3.58447 12.9217L10.4699 20.3191C11.315 21.227 12.685 21.227 13.5301 20.3191L20.4155 12.9217C22.5282 10.6519 22.5282 6.972 20.4155 4.70229C18.3029 2.43257 14.8777 2.43257 12.765 4.70229Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                </svg>
                                                <h1 className='font-bold text-gray-500 text-[15px] group-hover:text-black'>{t("Favorites")}</h1>
                                            </div>
                                        </li>
                                        <li onClick={() => HandleNavigate("/wallet")} className='py-[10px] px-[10px] cursor-pointer group'>
                                            <div className="flex items-center gap-[10px]">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                    <path d="M22 6C22 3.79086 20.2091 2 18 2H12C9.79086 2 8 3.79086 8 6V6H22V6Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                    <path d="M2 12L2 16L6 16C7.10457 16 8 15.1046 8 14V14C8 12.8954 7.10457 12 6 12L2 12Z" stroke="#28303F" stroke-width="1.5" stroke-linejoin="round" />
                                                </svg>
                                                <h1 className='font-bold text-gray-500 text-[15px] group-hover:text-black'>{t("Wallet")}</h1>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="flex items-center gap-[5px]">
                                        <button onClick={() => HandleNavigate("/profile")} style={{ borderRadius: "50px", padding: "5px 10px", margin: "0" }} className='button'>{t("Account")}</button>
                                        <button onClick={HandleLogOut} className='w-[100%] border-[2px] rounded-[50px] py-[5px] font-bold text-gray-600 hover:bg-[#000000c9] hover:text-white'>{t("Log out")}</button>
                                    </div>
                                </div>
                            </div>}
                        </div>

                    </div>

                    {isLoginShow && <div onClick={() => setIsLoginShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                        <div onClick={(e) => e.stopPropagation()} className="model">
                            <Login />
                        </div>
                    </div>}

                    {isSignUpShow && <div onClick={() => setIsSignUpShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
                        <div onClick={(e) => e.stopPropagation()} className="model">
                            <Signup />
                        </div>
                    </div>}

                </div>
            </div>

            {locationError && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-bold">{t("Enable Location Services")}</h2>
                            <img src={LocationImg} alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("To provide accurate services, please enable your location.")}</h6>
                                </div>
                                <div className="flex gap-[5px]">
                                    <span className="text-[18px]">2.</span>
                                    <h6> {t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleLocationEnable} className="button">{t("Enable Now")}</button>
                            <button onClick={HandleLocationEnable} className="w-full border-[2px] border-[#0000ffb7] font-bold text-[#0000ffb7] mt-[10px] p-[10px] rounded-[10px]">{t("Default")}</button>
                        </div>
                    </div>
                </div>
            )}

            {notificationerror && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-bold">{t("Enable Smart Alerts")}</h2>
                            <img src={NotificationImg} className='w-[100%] rounded-[10px]' alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("Let us notify you about upcoming bookings, changes, and key updates directly through your browser.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleNotificationEnable} className="button">{t("Enable Now")}</button>
                        </div>
                    </div>
                </div>
            )}

            {loading && <Loading />}

            {showMenu && <div className="overlay" onClick={() => setShowMenu(false)}></div>}
            {showNotification && <div className="overlay" onClick={() => setShowNotification(false)}></div>}
            {showLanguage && <div className="overlay" onClick={() => setShowLanguage(false)}></div>}
            {isValidate && <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]"> <Validation /></div>}

        </div>
    )
}

export default Header
/* jshint ignore:end */